// @flow
import React from "react";

require("./styles.scss");

const poster = require("images/haller-cover.jpg");
const posterMobile = require("images/haller-cover-mobile.jpg");

export function cover(props: { title: string, subtitle: string }) {
  const isMobile = window.innerWidth < 800;

  return (
    <div className="cover">
      <img src={isMobile ? posterMobile : poster} alt="" className="fallback" />

      <div className="top gradient" />
      <div
        className="ui mobile only"
        style={{
          position: "absolute",
          bottom: "0",
          left: 0,
          width: "100vw"
        }}
      >
        <div className="ui container">
          <div className="">
            <h1
              className="ui inverted left aligned header"
              style={{
                textAlign: "left"
              }}
            >
              {" "}
              {props.title}
            </h1>
            <div className="sub header">{props.subtitle}</div>
          </div>
        </div>
      </div>

      <div
        className="mobile hidden"
        style={{
          position: "absolute",
          bottom: "1em",
          left: 0,
          width: "100vw"
        }}
      >
        <div className="ui left aligned container">
          <div className="">
            <h1 className="ui inverted header" style={{}}>
              {props.title}
              <div className="sub header">{props.subtitle}</div>
            </h1>
          </div>
        </div>
      </div>
    </div>
  );
}

export default cover;
